/*
 * @Author: Merlin
 * @Date: 2023-11-30 10:49:04
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-30 11:55:05
 * @Description: 
 */

import { useGameSocket } from '~/socket/game';
import {useCrashSocket} from '@/socket/game/crash.ts';
import { useJoinStateStore } from '~/stores/cansino/joinState';
import { useGameHistorySocket } from '~/socket/gamehistory';
import {betableCheck} from '@/common/js/betHelper';

// ↓ 一些图 -----------------------------------------------------
import sStarPink from '../img/star-pink.png';
import sStarRed from '../img/star-red.png';
import sStarBlue from '../img/star-blue.png';
import sStoneSharp from '../img/stone-sharp.png';
import sStoneRound from '../img/stone-round.png';
import sStoneNarrow from '../img/stone-narrow.png';
import sStoneWide from '../img/stone-wide.png';
import sStripeDeep from '../img/stripe-deep.png';
import sStripeShallow from '../img/stripe-shallow.png';
import sStripeSmall from '../img/stripe-small.png';
// ↓ 一些音乐 -----------------------------------------------------
import crashBGM from '../audio/crash-bg.mp3';
import countDown01 from '../audio/count-down01.mp3';
import explosion from '../audio/explosion.mp3';

const { 
    EMIT_GET_HISTORY, // 查询游戏历史信息（以往的开奖结果）
} = useGameHistorySocket();
const {
    EMIT_CRASH_BET, // 下注
    EMIT_CRASH_BET_STOP, // 用户提现
} = useCrashSocket();
const { 
    EMIT_GETHISTORY_ON_JOIN, // 查询游戏下方表格的 all, high, rare
} = useGameSocket();


// 音乐列表
const oMusicLib = {
    bg: {
        src: crashBGM,
        loop: true,
        isBGM: true, // true-false 表示音量取自 globalVolume, globalSoundEffects
    },
    countDown01:{
        src: countDown01,
    },
    explosion:{
        src: explosion,
    },
}



function getStripeArr(){
    const aResult =  [{
        sUrl: sStripeDeep,
        opacity: 0.5,
    },{
        sUrl: sStripeShallow,
    },{
        sUrl: sStripeSmall,
    }].map(cur=>{
        cur.scale = getRandomFloat(1.3, 1.8);
        cur.speed = getRandomFloat(0.6, 0.8);
        cur.lateralMove = getRandomFloat(-4, 4);
        cur.zIndex = 1;
        return cur;
    }).sort(() => Math.random > 0.5);
    return aResult;
}

function  getStones(){
    const aStone = [{
        sUrl: sStoneSharp,
    },{
        sUrl: sStoneRound,
    },{
        sUrl: sStoneNarrow,
    },{
        sUrl: sStoneWide,
    }].map(cur=>{
        cur.scale = getRandomFloat(0.4, 0.8);
        cur.speed = getRandomFloat(2.5, 4.5);
        cur.lateralMove = getRandomFloat(-35, 35);
        cur.zIndex = 3;
        return cur;
    });
    aStone.sort(() => Math.random() - 0.5);
    return aStone;
}

function getStarArr(){
    const aStar = [{
        sUrl: sStarPink,
    },{
        sUrl: sStarRed,
    },{
        sUrl: sStarBlue,
    }].map(cur=>{
        cur.scale = getRandomFloat(0.2, 0.5);
        cur.speed = getRandomFloat(0.7, 1.0);
        cur.lateralMove = getRandomFloat(-25, 25);
        cur.zIndex = 2;
        return cur;
    });
    return aStar;
}

let aPictureBoxes = [];
let aRecord = [];
let iBoxNumber = -1;
let overallIndex = 0; // 无限上涨

// ↓ 倍数转级别，用于按级别取得颜色和类名等 
export function multi2Level(multi){
    const multiValue = Number(multi);
    if (multiValue >= 10) return 0;
    if (multiValue >= 2) return 1;
    return 2;
}

export const aboutBackgroundWall = {
    // ↓ 在 created 时，游戏启动时执行
    setPictureBoxesArr(){
        const arr = [ 
            getStripeArr(),
            getStones(),
            getStones(),
            getStones(),
            getStarArr(),
            getStones(),
            getStones(),
            getStones(),
        ];
        aPictureBoxes = arr;
        aRecord = arr.map(() => -1);
        iBoxNumber = -1;
        overallIndex = 0; 
    },
    getOnePic(){
        iBoxNumber++;
        overallIndex++;
        if (iBoxNumber >= aPictureBoxes.length){
            iBoxNumber = 0;
        }
        aRecord[iBoxNumber]++;
        if (aRecord[iBoxNumber] >= aPictureBoxes[iBoxNumber].length){
            aRecord[iBoxNumber] = 0;
        }
        const idx02 = aRecord[iBoxNumber];
        const oPic = aPictureBoxes[iBoxNumber][idx02];
        oPic.overallIndex = overallIndex;
        if(0 && import.meta.dev){
            console.log(`背景图编号: ${iBoxNumber}-${idx02} {${overallIndex}}`);
        }
        return oPic;
    },
    // ↓插入一个石头，星球等图
    async insertOnePic(){
        const toSkip = [
            // ↓ 页面未激活则不插入，防止用户离开过久再切换回来的时候页面有大量背景元素堆积出现 
            document.visibilityState != 'visible',
            !this.isShowAnimation,
        ].some(Boolean);
        if (toSkip) return;
        const oPic = this.getOnePic();
        this.aPicOnWall.unshift(oPic); // 头部插入
        if (this.aPicOnWall.length < 15){
            return;
        }
        setTimeout(()=>{ // 建立退让点
            this.aPicOnWall.splice(10, 1/0); // 尾部删除
        });
    },
};


// ============== 👆以上是内部方法 ==================================================


// ▼其它方法
const fns = {
    getGoatDom(oGoatDom){
        this.oCoatMainDom = oGoatDom;
        this.observeGoatDom();
    },
    async observeGoatDom(){
        if (!this.oCoatMainDom) return;
        if (!this.bCrashMounted) return;
        await this.$nextTick();
        this.oCoatMainHeight = this.oCoatMainDom.offsetHeight
        const oMyObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                // const newHeight = entry.contentRect.height;
                // console.log(`新高度：`, newHeight, this.oCoatMainDom.offsetHeight);
                const iGrew = this.oCoatMainDom.offsetHeight - this.oCoatMainHeight;
                console.log(`长高了：`, iGrew);
                this.height02 = iGrew;
            }
        });
        oMyObserver.observe(this.oCoatMainDom);
    },
    toChangeMode(isAuto){
        this.isAutoMode = !!isAuto;
        if (isAuto){
            this.oAutoDialog.switchAutoDialogVisible(true);
        }
    },
    // ↓ 隐藏历史面板 
    hideHistoryBox(){
        const {oMenuBox} = this.oHistoryControl;
        oMenuBox.hide();
    },
    // ↓ 切换历史开奖面板的内容位置（左右滑动内容）
    switchHistoryDataInShow(){
        const {oPillarBox, seeStart} = this.oHistoryControl;
        const bNewVal = !seeStart;
        this.oHistoryControl.seeStart = bNewVal;
        if (!oPillarBox) return console.error('no dom');
        const goTo = bNewVal ? 0 : -999;
        this.$nextTick(() => {
            oPillarBox.scrollTo(goTo, 0);
        });
    },
    multi2Level,
    // 👇 控制 jackpot 弹出窗口可见性 
    jackpotControler(newVal){
        if (typeof newVal === 'boolean'){
            this.oVisible.jackpotVisible = newVal;
        }else{
            this.oVisible.jackpotVisible = false;
        }
    },
    createMusicControler(){
        console.log("this.MusicControler");
        console.log(this.MusicControler);
        this.MusicControler = new MusicControler(oMusicLib);
    },
    togglePlayerInfo(){
        this.bPlayerVisible = !this.bPlayerVisible;
    },
    // 👇点击下注按钮（这是下注按钮的唯一处理事件）
    clickOnBetButton(){
        // console.log('[点击按钮] iJoinMark:', this.iJoinMark, 
        //     'state:', this.oAnimation?.state, 
        //     'name:', this.oAnimation?.name, 
        //     'isAutoMode:', this.isAutoMode,
        //     'isSubmiting:', this.oForm.isSubmiting);
        if (this.iJoinMark == 2){ // 如果已经预约下局投注了，则取消 
            this.iJoinMark = 0; 
            this.oForm.isSubmiting = false; 
            console.log("已经取消预约", );
        } else if (this.iJoinMark == 1){ // 如果已经押注本局，则提现
            this.oSelfRound = {};
            if (this.oAnimation?.state === 'fly'){
                this.userCashOut(); // 提现
                this.oToolKit.stopInfinity(); // 关停自动模式
                this.iJoinMark = 0;
            }else if (this.oAnimation?.name === 'BETTING'){
                this.isPlanningToSotpAutoBet = true;
            }else if (this.oAnimation?.state === 'crash' || this.oAnimation?.name === 'PREPARING_NEXT_ROUND'){
                // console.log('[点击按钮] crash/PREPARING_NEXT_ROUND 阶段，执行停止自动模式');
                this.oToolKit.stopInfinity();
                this.iJoinMark = 0;
                this.oForm.isSubmiting = false; 
            }else{
                console.warn('状态失常', 'state:', this.oAnimation?.state, 'name:', this.oAnimation?.name);
                // 状态失常时也要停止自动模式和重置状态
                this.oToolKit.stopInfinity();
                this.iJoinMark = 0;
                this.oForm.isSubmiting = false;
            }
        }
        // 👆 已经预约了，或游戏进行中，执行取消预约，或提现等 
        // 👇 未下注则下注，或预约下注
        else if(betableCheck(this.oForm)){
            this.oSelfRound = {}; // 清空
            this.placeABet(); // 其内部会按需执行立即下注或预约下注 
        }
    },
    // 👇 启动处理自动下注
    startAutoBet(){
        console.log("开始自动下注");
        this.iJoinMark = 1;
        this.isPlanningToSotpAutoBet = false;
        this.oForm.isSubmiting = true;
        this.oToolKit.startInfinity();
    },
    // 👇 关停自动模式，并恢复状态
    stopAutoBetIfNeed(){
        const aCondition = [
            this.oForm.isSubmiting === false,
            this.isPlanningToSotpAutoBet,
        ];
        const bResult = aCondition.some(Boolean);
        console.log('Crash 游戏是否要关停自动模式：', bResult);
        if (bResult){
            this.iJoinMark = 0;
            this.isPlanningToSotpAutoBet = false;
        }
    },
    // 下注方法
    placeABet(){
        // 427["games.crash.bet",{"amount":"100.00000000","autoStop":2,"frontID":1703585034459}]	
        const {oAnimation} = this;
        console.log("下注方法打印 oAnimation.name =", oAnimation.name || '无'); 
        // oAnimation.coef // ← coef 为0时才能下注 
        if (oAnimation.name === 'BETTING'){ // ◀ 这是能下注的唯一时机
            if (this.isAutoMode) this.startAutoBet();
            else this.betForThisTurn();
        }else{ // 其它状态都不能下注，执行预约下注
            console.log("已经预约下局参加游戏", );
            this.iJoinMark = 2; 
        }
    },
    // 👇 投注到“本局” （提交到后台）
    // ↓ autoBet 工具包正是用的这个方法提交
    async betForThisTurn(){
        console.log("参加本局游戏：开始提交");
        const oBetInfo = {
            amount: getFixed(this.oForm.amount, 2),
            autoStop: this.oForm.cashoutAt, // 自动终止于x倍
            frontID: Date.now(),
        }
        // if (import.meta.env.DEV_MODE && this.isAutoMode && Math.random() <= 0.3){
        //     oBetInfo.amount = '0'; 
        // }
        this.iJoinMark = 1; // 下注到本局
        this.joinStateStore.gameRunning = true; //标记游戏正在进行中 
        // ↓ 返回给自动下注工具包 
        const oPromise = new Promise((f1, f2) => {
            // 稍后 this.fnResolve 将被调用，并执行一系列动作
            // 爆炸后会主动查询某接口查询结果，然后会调用以下方法 
            this.fnResolve = f1;
        });
        EMIT_CRASH_BET(oBetInfo, res => {
            console.log("下注后台返回值\n：", deepCopy(res));
            if (!res || res?.error){
                this.iJoinMark = 0; // 未能下注，状态复位
                // ↓ 手动模式在此弹出提示，自动模式在工具包内弹 
                if (!this.isAutoMode){
                    showNegativeNotify(res?.error); 
                }
                this.fnResolve(res); // 立即回报下注出错， 
                return;
            }
            this.iJoinMark = 1; // 下注到本局，不是重复赋值，它有容错意义
            this.oRound.id = res._id; // 保存下注 id
        });
        return oPromise;
    },
    // 👇 当前玩家“主动” 提现（提交到后台）
    userCashOut(){
        console.log("即将提现");
        this.iJoinMark = 0;
        this.oSelfRound = {}; // 清空 
        EMIT_CRASH_BET_STOP({}, res=>{
            // 没有返回值，不会执行到此
            // 在 gamesCrashStopped() 内部才能接收到提现成功的返回值
            console.log("已经提现 🤣", res);
        });
    },
    // ▼ 处理 Cashout at 倍数的增减
    cashoutAdjuster(direction){
        const {oForm, aCashoutLimites} = this;
        let newValue = Math.round(
            oForm.cashoutAt + direction
        );
        if (newValue < aCashoutLimites.min){
            newValue = aCashoutLimites.min;
        }else if(newValue > aCashoutLimites.max){
            newValue = aCashoutLimites.max;
        }
        oForm.cashoutAt = newValue;
    },
    // ↓ 更新游戏历史（每局结束后调用）
    updateHistory4All(){
        EMIT_GETHISTORY_ON_JOIN('crash', {}, (data)=>{
            const joinStateStore = useJoinStateStore();
            if (data?.all){
                joinStateStore.history.all = data.all;
            }else{
                console.error("Crash 大表格数据查询失败\n", deepCopy(data));
            }
        });
    },
    // ↓ 更新“自已的” 游戏历史（每局结束后调用，爆炸后调用） 
    updateHistory4Me(){
        const iRoundID = this.oRound.id;
        if (!iRoundID) return; // 没下注则停止
        const oQueryInfo = {
            page: 1,
            category: 'dapps',
            game: this.joinStateStore.gameId,
        };
        let {oPromise, resolve} = (
            this.isAutoMode ? createPromise() : {}
        );
        this.oBetResultPromise = oPromise;
        console.log("当前玩家 crash 游戏结果：开始查询", );
        const toSave = (res) => {
            res = deepCopy(res || {});
            // res 结构： {count : 183, providers : {}, response :[]}
            const {response, count, providers} = res;
            if (!response){
                console.error("当前玩家 crash 游戏结果查询失败\n", deepCopy(res)); 
                return; 
            }
            this.gameHistoryStore.historyData.count = count;
            this.gameHistoryStore.historyData.providers = providers;
            const oMine = response.find(cur => {
                return cur._id === iRoundID;
            });
            if (!oMine) return; // ◀ 按道理，通常不会执行 return
            resolve?.(oMine); // 用于宣告：已经取得了游戏结果了
            console.log(`当前玩家 crash 游戏结果查询完毕↓\n`, oMine);
            this.gameHistoryStore.historyData.response.unshift(
                oMine
            );
        };
        EMIT_GET_HISTORY(oQueryInfo, toSave);
    },
};


const aNetworkRecord = [];

// 用于接收信息，处理信息
const orderHandler = {
    // ↓ 检查网络质量 
    async fnCheckNetwork(){
        if (!this.timerForNetworkCheck) return;
        const delay = 1_500;
        const t01 = Date.now();
        socket.emit("ping", {}, () => {
            setNetworkStatus(Date.now() - t01);
            if (window?.scheduler?.postTask){
                window.scheduler.postTask(this.fnCheckNetwork, {
                    delay,
                    priority: 'background',
                });
            }else{
                setTimeout(this.fnCheckNetwork, delay)
            }
        });
        // ↓ 设定网络状态 
        const setNetworkStatus = (iGap)=>{
            aNetworkRecord.push(iGap);
            if (aNetworkRecord.length > 3){
                aNetworkRecord.shift();
            }
            const iAverageGap = aNetworkRecord.reduce((aa, bb) => {
                return aa + bb;
            }, 0) / aNetworkRecord.length;
            const sSecond = new Date().getSeconds();
            const toPrint = sSecond % 5 === 0; // x 秒打印一次，防止太频繁 
            if (1 && toPrint){
                console.log("单次延时", iGap, '◆ 平均值', iAverageGap);
            }
            // 光速“往返”狮城与一些城市的耗时(ms) 如下 🔶 一次 ping pong 即是一次往返 
            // 香港18,  成都22,  上海26,  北京37,  悉尼41,  迪拜40,  莫斯科57, 
            this.iNetworkStatus = (()=>{
                if (iAverageGap <= 90) return 0; // 优 
                else if (iAverageGap <= 110) return 1; // 良 
                return 2; // 差 
            })();
        };
    },
    // 👇接收消息的“唯一”方法，在此向其它方法分派工作
    async orderReciever(oMsg, sMsgType){
        // const t01 = Date.now();
        const fnMapObj = { 
            'games.crash.fly' : this.gamesCrashFly, // fly, crash
            'games.crash.state' : this.gamesCrashState, // BETTING, STOP_BETTING
            'games.crash.stopped' : this.gamesCrashStopped, // 接收用户提现通知
            'crashbethistory' : this.manageOtherPlanyer, // 接收玩家加入游戏的通知
            'games.crash.info' : this.gamesCrashInfo, // 
        };
        const fn = fnMapObj[sMsgType];
        if (!fn) return;
        fn(oMsg);
        this.afterUpdated(oMsg);
        // console.log('消息处理耗时：', Date.now() - t01);  // 通常是 0-1之间
    },
    // 👇 收到后台消息之后做处理
    afterUpdated(oMsg){
        // ↓ 但凡 “终止下注” 的条件触发了，立即标记为“停止下注” 
        if (oMsg.name === 'BETTING'){
            this.iRoundIndex++;
            this.oAnimation.hasStoppedBetting_ = false;
            if (this.iJoinMark === 2){ //无论是否自动模式，都应该将预约转为此刻下注
                this.iJoinMark = 1;
            }
        }else if (oMsg.name === 'STOP_BETTING'){
            this.iRoundIndex++;
            this.oAnimation.hasStoppedBetting_ = true;
        }else if (oMsg.state === 'crash'){ // 本局游戏结束了 
            // console.log("爆炸了 💥💥💥💥💥💥 state");
            this.oSelfRound = {}; // 清空 
            if (!this.isAutoMode){
                this.joinStateStore.gameRunning = false; // 标记为游戏结束
            }
            if (this.iJoinMark === 1){
                if (this.isAutoMode) {
                    // this.stopAutoBetIfNeed(); // 按条件清空下注状态
                }else{
                    this.iJoinMark = 0; // 清空下注状态
                    console.log("iJoinMark 归零：", this.iJoinMark);
                }
            }
            this.oRound.aUserJoined.forEach(cur => {
                if (!cur.stopped) cur.bang = 'bang';
            });
        }
        // ↓ 通过 bFirstLoadNotYet 使以下代码只执行一次
        const doFirstLoad = (
            this.bFirstLoadNotYet
            &&
            (oMsg.name?.includes('BETTING') || oMsg.state)
        );
        if (doFirstLoad){ 
            this.bFirstLoadNotYet = false;
            this.handleFirstState(oMsg);
        }
    },
    // 设定开场
    handleFirstState(oMsg){
        this.oStatus.isGroundGoDown = true; // 设定地面已经下降 
        this.oStatus.isPlaneGoUp = true; // 设定飞机已经腾空
        this.oStatus.hasCrashed = false; // 开始显示飞机
        this.insertOnePic();
    },
    // 👇延时移除飞机 dom 
    hidePlane(ms=500){
        setTimeout(()=>{
            if (import.meta.dev) console.log("开始销毁飞机 DOM", new Date().toISOString());
            this.oAnimation.state = ''; // 清空‘已爆炸’标记 
            this.oStatus.hasCrashed = true; // 销毁飞机 dom  
            this.oStatus.showCownDown = true; // 显示倒计时 
            this.$nextTick(); // 销毁飞机 DOM，最好等待，以使能顺利再显示
        }, ms);
    },
    // ▼ 保存 name 信息
    async gamesCrashState(oMsg){
        // ["games.crash.state",{"name":"STOP_BETTING","end":1703141351856}]
        // ["games.crash.state",{"name":"SHOW_RESULT","end":1703141351857}]
        // name 的可能值有：👉 PREPARING_NEXT_ROUND, BETTING, STOP_BETTING, SHOW_RESULT 
        // console.log("🧡 state name =", oMsg.name);
        this.oAnimation.name = oMsg.name;
        if(oMsg.name === 'PREPARING_NEXT_ROUND'){
            // ↓ 此时上局游戏彻底结束了，查出游戏的历史数据
            // ↓ 在 BETTING 状态到来时将清空 this.oRound 所以那之前执行
            this.updateHistory4All(); // 查验了原版，也是这样更新数据的。在 7.11 从爆炸后查询改到开局前查询
            this.updateHistory4Me();
            this.joinStateStore.jackpotUpdate();
            this.oStatus.isPlaneGoUp = false;
            this.oAnimation.total = 0; // 归零
            this.hidePlane(); // 需要保持先销毁，后重载，不要晚于重载 
            setTimeout(() => {
                this.MusicControler.oAudio.countDown01?.toPlay();
            }, 300);
        }else if (oMsg.name === 'BETTING'){
            this.nameBecomeBetting();
        }else if (oMsg.name === 'STOP_BETTING'){
            if (this.isAutoMode && this.iJoinMark > 0) {
                this.stopAutoBetIfNeed(); // 终止自动下注
            }
        }
    },
    // ↓ 状态变更为 name === 'BETTING' 才会调用此方法
    // ↓ 此时是下注的最早时机，早于此，则下注失败
    nameBecomeBetting(){
        this.oRound = deepCopy(this.oRound_); // 复位
        const hasWonJackpot = this.$refs.jackpotHandler.showJackpotWin();
        if (this.isAutoMode){
            if (this.iJoinMark === 1){
                // 如果是自动模式，需要报告上局结果，并触发再次下注
                console.log("自动模式，开始提取上局游戏结果");
                this.oBetResultPromise?.then?.(oGameResult => {
                    console.log("自动模式，上局游戏结果如下：\n", deepCopy(oGameResult));
                    this.fnResolve(oGameResult);
                });
            }else if (this.iJoinMark === 2){
                this.iJoinMark = 1; // 添加标记，防止再执行到此
                console.log("按预约，开始自动下注");
                this.startAutoBet();
            }
            if (hasWonJackpot){
                setTimeout(()=>{
                    this.$refs.jackpotHandler?.hideJackpotWin();
                }, 1_900);
            }
        } else {
            if (this.iJoinMark === 1){ 
                // 按道理走不到此处
            }else if(this.iJoinMark === 2){
                console.log("按预约，在本局下注");
                this.betForThisTurn(); // 下注到本局
            }
        }
        if (import.meta.dev || 1){
            console.log("开始显示：地面、飞机", new Date().toISOString());
        }
        this.oAnimation.coef = 0;
        this.aPicOnWall.splice(0, 1/0);
        this.oStatus.hasCrashed = false; // 显示飞机 dom 
        this.oStatus.isGroundGoDown = false; // 取消地面动画
        this.oStatus.isGroundShowing = true; // 显示地面
        let iMS = 0;
        setTimeout(()=>{
            this.oStatus.isGroundGoDown = true;
        }, iMS += 1700);
        setTimeout(()=>{
            this.oStatus.isPlaneGoUp = true; // 收到 fly 前飞机到完成升空
            this.setPictureBoxesArr();
            this.insertOnePic(); // 首次插入
        }, iMS += 1300);
    },
    // ▼ 保存 state, total, coef
    gamesCrashFly(oMsg){
        const hasCrashed = oMsg.state === 'crash';
        if(hasCrashed){
            this.MusicControler.oAudio.explosion?.toPlay();
            this.oSelfRound = {}; // 清空 
            this.joinStateStore.bets?.splice?.(0, 1/0); // 清空
        }else if(oMsg.state === 'fly'){
            // ↓ 这是起飞之前收到的最后一个 name 值，补充在此，防止游戏重载时出错 
            this.oAnimation.name = 'SHOW_RESULT';
        }
        // '42["games.crash.fly",{"state":"fly","total":37400,"coef":10.3101}]'
        // '42["games.crash.fly",{"state":"crash","total":37400,"coef":10.31}]'
        const {coef} = this.$refs;
        // 在 if 内手工赋值，防止频繁刷新数据，触发页面渲染 
        if (coef) {
            coef.textContent = oMsg.coef.toFixed(2); // 页面中心的倍数信息
        }
        // ↓ 没下注时找不到这个 DOM 
        const sDom = `.button-2rows .second-row[class~=show-crash-money]`; 
        const showMoneySpan = [...document.querySelectorAll(sDom)];
        if (showMoneySpan[0]){
            let winMoney = (
                (this.oSelfRound.amount || this.oForm.amount || 0)
                * oMsg.coef
            );
            winMoney = winMoney.toFixed(
                winMoney > 1_000 ? 1 : 2 // 防止太宽，横向空间不足 
            );
            const currency = this.oSelfRound.currency || this.joinStateStore.currency || '';
            if (currency) winMoney += `<br/>${currency.toUpperCase()}`;
            requestAnimationFrame(()=>{
                if (this.oRound.stoppedAt || hasCrashed) return; 
                showMoneySpan.forEach(cur => {
                    cur.innerHTML = winMoney;
                });
            });
        }
        this.oAnimation.state = oMsg.state;
        const saveVal = hasCrashed || (this.oAnimation.coef == 0);
        // ↓ 仅在特定时机赋值 2 次，防止频繁刷新 dom （似乎没起什么大作用）
        if (saveVal){ 
            this.oAnimation.total = oMsg.total;
            this.oAnimation.coef = oMsg.coef;
        }
        if ((oMsg.total % 2500 === 0) && (oMsg.total >= 2000)){
            // console.log("插图：", deepCopy(oMsg));
            this.insertOnePic();
        }
    },
    gamesCrashInfo(){
        
    },
    // ↓ 当前玩家或其它玩家提现消息
    gamesCrashStopped(oMsg){
        // oMsg 结构：{id: 25597, stop: 1.135, total: 1800}
        // 42["games.crash.stopped",{"id":24545, "stop":1.48, "total":6400}]
        oMsg.self_ = this.oRound.id === oMsg.id;
        // let selfID = this?.oUserStore?.id; // ←有时这个查不到
        // selfID ||= this.gameHistoryStore.historyData.response?.[0]?.user?._id;
        console.log(`玩家提现，当前玩家？`, oMsg.self_, oMsg);
        this.othersStopped(oMsg);
        // Array(22).fill(1).forEach(cur=>{ // 用于测试动画效果
        //     this.othersStopped(JSON.parse(JSON.stringify(oMsg)));
        // });
        if (!oMsg.self_) return;
        const self = this?.oRound.aUserJoined?.filter(it=>it._id == oMsg.id)[0];
        self.stopped = oMsg.stop;
        self.iTimes = oMsg.stop;
        self.stoppedAt = oMsg.stop;
        // ↓ 值为 true 表示自动下注中，值为 false 时方可标为游戏已结束 
        if (this.oForm.isSubmiting == false){
            this.joinStateStore.gameRunning = false; // 标记游戏已结束 
        }
        if (!this.isAutoMode){
            this.iJoinMark = 0; // 非自动模式时将下注状态归位 
        }
        this.oRound.stoppedAt = oMsg.stop;
    },
    // 👇本局游戏下注用户列表
    // 通过 watch 调用，在页面加载时执行一次
    manageUsersJoin(aUsers){
        let selfID = this?.oUserStore?.id; // ←有时这个查不到
        selfID ||= this.gameHistoryStore.historyData.response?.[0]?.user?._id;
        if (!selfID && import.meta.dev) {
            console.error("注意，未能取得当前用户 ID", );
        }
        let hasBetted = false; // 值为 true 表示当前用户参加了下注  
        aUsers.forEach(cur => {
            // 在游戏及途中收到的实时消息是用属性 “id” 记录的游戏 id 
            // 在游戏初始化时 .bets 上则用 _id，记录，所以在此补充一下 id 
            cur.id = cur._id; 
            this.manageOtherPlanyer(cur);
            cur.self_ = (cur.user._id === selfID);
            if (!cur.self_) return;
            hasBetted = true; // 表示当前用户参加了下注 
            console.log("通过 Watch 找到了当前用户“自已” 的数据\n", deepCopy(cur), '\n', JSON.stringify(cur));
            this.setUserSelf(cur);
        });
        return hasBetted; 
    },
    // ↓ 设定当“前用户” 的游戏状态
    setUserSelf(oUserSelf){
        // { "winAmount": 0, "difference": 0, "stopped": 0, "confirmed": false, "balanceBefore": 99632250.5191229, "_id": 31272, "hash": "88fa2e1032f70d00b7429aee9905d348a091e868abf183eb9611ebab0fa43766", "isVip": false, "minedTokens": 0, "user": { "_id": 70, "address": "", "avatar": 0, "lvl": 1, "name": "User002x70" }, "roundNum": "57290", "amount": 222, "currency": "cny", "autoStop": 100, "baseAmount": 0, "timestamp": "2024-02-06T08:55:02.000Z", "agent_id": 0, "agent_uid": "70", "game": { "_id": 7 }, "min": 1, "iTimes": 0, "iCashout": 0 }
        oUserSelf.stopped *= 1;
        const {stopped} = oUserSelf;
        const iJoinMark = stopped ? 0 : 1;
        this.iJoinMark = iJoinMark;
        this.oRound.id = oUserSelf._id;
        this.oSelfRound = deepCopy(oUserSelf);
        // console.log("当前用户提现了吗：", stopped);
        if (stopped){ // 如果已经提现了，标为“已提现” 
            this.othersStopped({
                ...oUserSelf,
                stop: stopped,
            }, true);
        }
    },
    // 👇 玩家（有可能是当前用户自已）加入
    manageOtherPlanyer(oMsg){
        // console.log("玩家加入：\n", oMsg);
        oMsg.iTimes = 0; // 提现倍数
        oMsg.iCashout = 0; // 提现金额
        this.oRound.aUserJoined.push(oMsg);
        this.oRound.oUserJoined[oMsg._id] = oMsg; // _id 是下注 id
    },
    // 👇 “其它”玩家提现下车
    othersStopped(oMsg){
        const oTarget = this.oRound.oUserJoined[oMsg.id]; // oMsg.id
        if (!oTarget) {
            if (1 || import.meta.dev){
                console.warn(`未能定位到提现人 _id: ${oMsg._id}, id: ${oMsg.id}`);
                console.log("this.oRound\n", deepCopy(this.oRound));
                console.log("joinStateStore.bets\n", deepCopy(this.joinStateStore.bets));
                // 经过研究，偶尔定位不到是正常的。其它户下注的实时消息推送到此的时候，当前用户的监听尚未建立，漏掉了。 
            }
            return; 
        }
        oTarget.stopped = 1; // 标为已经提现
        oTarget.iTimes = oMsg.stop; // 标出提现倍数
        oTarget.iCashout = oTarget.amount * oMsg.stop; // 标出提现倍数
        // console.log('提现用户：', deepCopy(oTarget)); 
        if (oMsg.self_) return;
        // ▲通用部分 ▼ 其它玩家专用部分
        const [iNow, iGapMS] = [Date.now(), 130]; // 每次插入需要间隔 xx 毫秒
        const iDelay = (()=>{
            const {iCheckOutAt} = this.oRound;
            if (!iCheckOutAt) return 10; // 0延时插入
            if (iNow - iCheckOutAt > iGapMS) return 10; // 0延时插入
            const iVal = iCheckOutAt + iGapMS - iNow; // 延时
            return iVal;
        })();
        // console.log("延时：", iDelay);
        this.oRound.iCheckOutAt = iNow + iDelay;
        // ↓ 每个用户的退出消息不能拥堵式插入，要有间隔（delay）
        setTimeout(()=>{
            this.oRound.cashoutUsers.push(oTarget);
        }, iDelay);
        // ↓ 动画播放完毕就删除（似乎没必要，先保留
        setTimeout(() => {
            for (const [idx, val] of this.oRound.cashoutUsers.entries()){
                if (val._id === oTarget._id){
                    this.oRound.cashoutUsers.splice(idx, 1);
                    break;
                }
            }
        }, 5_000);
    },
}


export const methods = {
    ...fns,
    ...orderHandler,
    ...aboutBackgroundWall,
}


// 👇 其它用户提现（ 调用 .jion 在返回值的 bets:[] 也是相同格式的数据
// {
//     "winAmount": 0,
//     "difference": 0,
//     "stopped": 0,
//     "confirmed": false,
//     "balanceBefore": 994191.38208299,
//     "_id": 25606,
//     "hash": "b952c1620ee968e0e2d89e3ebfef5dab8079eb43f24c88d4866c667c95b8a71a",
//     "isVip": false,
//     "minedTokens": 0,
//     "user": { "_id": 2, "address": "", "avatar": 0, "lvl": 1, "name": "nb666" },
//     "roundNum": "29059",
//     "amount": 2e-8,
//     "currency": "usdt",
//     "autoStop": 1.33,
//     "baseAmount": 0,
//     "timestamp": "2024-01-22T10:36:51.000Z",
//     "agent_id": 0,
//     "agent_uid": "2",
//     "game": { "_id": 7 },
//     "min": 1
// }


/*
42["games.crash.fly",{"state":"fly","total":15600,"coef":2.6463}]
42["games.crash.fly",{"state":"crash","total":15600,"coef":2.64}]
42["games.crash.state",{"name":"PREPARING_NEXT_ROUND","end":1703821929168}]
["games.crash.state",{"name":"STOP_BETTING","end":1703141436429}]
["games.crash.state",{"name":"SHOW_RESULT","end":1703141436430}]
*/

